// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartSummarySharedStyles from "@guestsupply/App/SharedStyles/CartSummarySharedStyles";
import { totalStyles } from "@guestsupply/Overrides/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { css } from "styled-components";

totalStyles.container = {
    ...cartSummarySharedStyles.container,
};
totalStyles.titleGridItem = {
    ...cartSummarySharedStyles.titleGridItem,
};
totalStyles.labelGridItem = {
    ...cartSummarySharedStyles.labelGridItem,
};
totalStyles.valueGridItem = {
    ...cartSummarySharedStyles.valueGridItem,
};
totalStyles.subtotalLabelText = {
    ...cartSummarySharedStyles.labelText,
};
totalStyles.subtotalValueText = {
    ...cartSummarySharedStyles.valueText,
};
totalStyles.discountsLabelText = {
    ...cartSummarySharedStyles.labelText,
};
totalStyles.discountsValueText = {
    ...cartSummarySharedStyles.valueText,
};
totalStyles.shippingAndHandlingLabelText = {
    ...cartSummarySharedStyles.labelText,
};
totalStyles.shippingAndHandlingValueText = {
    ...cartSummarySharedStyles.valueText,
};
totalStyles.otherChargesLabelText = {
    ...cartSummarySharedStyles.labelText,
};
totalStyles.otherChargesValueText = {
    ...cartSummarySharedStyles.valueText,
};
totalStyles.taxLabelText = {
    ...cartSummarySharedStyles.labelText,
};
totalStyles.taxValueText = {
    ...cartSummarySharedStyles.valueText,
};
totalStyles.dividerGridItem = {
    ...cartSummarySharedStyles.dividerGridItem,
};
totalStyles.totalLabelText = {
    ...cartSummarySharedStyles.totalLabel,
};
totalStyles.totalValueText = {
    ...cartSummarySharedStyles.totalValue,
};
totalStyles.fullWidthGridItem = {
    width: 12,
};
totalStyles.invoiceSummaryLabel = {
    ...cartSummarySharedStyles.titleText,
};
totalStyles.onlineMessage = {
    width: 12,
    css: css`
        padding: 8px 9px;
    `,
};
